module.exports = __webpack_public_path__ + "ec156f9c448058d7268a093a8c3c6c61.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-20.png
// module id = 2529
// module chunks = 0